export const PAGE_OUR_STORY = 'our-story';
export const PAGE_MIDI = 'midi';
export const PAGE_PROJECT_INFO = 'project-info';
export const PAGE_WHY_ORLUNA = 'why-orluna';
export const PAGE_SUSTAINABILITY = 'sustainability';
export const PAGE_CONTACT = 'contact';
export const PAGE_HOME = 'home';
export const PAGE_RANGE = 'range';
